<template>
  <div class="toc-layout layers">
    <div class="scroller" ref="scroller">
      <div class="long-content" ref="content">

        <div class="top-taller"></div>

        <div class="col">
          <div class="row title-row">
            <div class="magic-width title" v-if="SC.U === ENG">
              Terms and Conditions
          </div>
            <div class="magic-width title" v-if="SC.U === CHI">
              條款及細則
            </div>
          </div>
          <div class="row text-row">
            <!-- <div class="magic-width text" v-if="SC.U === ENG">
              <br />  
               1. All registered information shall base on the computer records of Clé de Peau Beauté and its marketing partners.
              <br />  
              <br />  
              2. Participants shall comply with the rules, terms and conditions as well as other relevant requirements set out by Clé de Peau Beauté and shall guarantee that all information provided is true and correct without using fraudulently or misappropriating the information of ay third parties.  In the event of breach, Clé de Peau Beauté shall be entitled to cancel participant’s qualification.
              <br />  
              <br />  
              3. The participation of the activity is on a voluntary basis; Clé de Peau Beauté shall be freed from any liabilities from the activity and be exempted from all legal liabilities and compensation.
              <br />  
              <br />  
              4. All participants understand and are willing to comply with the terms and conditions set by Clé de Peau Beauté.
              <br />  
              <br />  
              5. In the event of any disputes, Clé de Peau Beauté shall reserve the right on final decision including suspending, changing or terminating the activity and its terms and conditions at any time without further notice.
            </div> -->
            <div class="magic-width text">
              <!--
                old
                <ol class="rule-list">
                <li>所有登記資料以Clé de Peau Beauté及其市場推廣合作夥伴的電腦紀錄為準。</li>
                <li>參加者必須遵守Clé de Peau Beauté所訂立的規則、條款及細則及其他有關之規定，並保證所提供之資料均為真實且正確，且未冒用或盜用任何第三人之資料。如違規者，Clé de Peau Beauté有權取消其參加資格。</li>
                <li>參加者屬自願性質參加是次活動，一切因是次活動所構成之責任與Clé de Peau Beauté無關，Clé de Peau Beauté將免除一切法律責任及賠償。</li>
                <li>是次活動的參加者了解並願意遵守Clé de Peau Beauté訂立的條款及細則。</li>
                <li>如有任何爭議，Clé de Peau Beauté保留最終決定權，包括隨時暫停、更改或終止活動及其條款及細則，而毋須另行通知。</li>
              </ol>
               -->

              <ol class="rule-list" v-if="SC.U === CHI">
                <li>所有登記資料以Clé de Peau Beauté及其市場推廣合作夥伴的電腦紀錄為準。</li>
                <li>參加者必須遵守Clé de Peau Beauté所訂立的規則、條款及細則及其他有關之規定，並保證所提供之資料均為真實且正確，且未冒用或盜用任何第三人之資料。如違規者，Clé de Peau Beauté有權取消其參加資格。</li>
                <li>參加者屬自願性質參加是次活動，一切因是次活動所構成之責任與Clé de Peau Beauté無關，Clé de Peau Beauté將免除一切法律責任或賠償。</li>
                <li>是次活動的參加者了解並願意遵守Clé de Peau Beauté訂立的條款及細則。</li>
                <li>如有任何爭議，Clé de Peau Beauté保留最終決定權，包括隨時暫停、更改或終止活動及其條款及細則，而毋須另行通知。</li>
              </ol>

              <ol class="rule-list" v-if="SC.U === ENG">
                <li>All registered information shall base on the computer records of Clé de Peau Beauté and its marketing partners.</li>
                <li>Participants shall comply with the rules, terms and conditions as well as other relevant requirements set out by Clé de Peau Beauté and shall guarantee that all information provided is true and correct without using fraudulently or misappropriating the information of any third parties.  In the event of breach, Clé de Peau Beauté shall be entitled to cancel participant’s qualification.</li>
                <li>The participation of the activity is on a voluntary basis; Clé de Peau Beauté shall be free from any liabilities from the activity and be exempted from all legal liabilities or compensation.</li>
                <li>All participants understand and are willing to comply with the terms and conditions set by Clé de Peau Beauté.</li>
                <li>In the event of any disputes, Clé de Peau Beauté shall reserve the right on final decision including suspending, changing or terminating the activity and its terms and conditions at any time without further notice.</li>
              </ol>
            </div>
          </div>
          <CTA :text="'BACK'" v-if="SC.U === ENG" @action="$router.go(-1)" />
          <CTA :text="'返回'" v-if="SC.U === CHI" @action="$router.go(-1)" />
          <!-- <div class="row back-row" @click="$router.go(-1)">
            <img class="back-frame" src="./img/back-frame.svg" />
            <div class="magic-width back" v-if="SC.U === ENG">
              BACK
            </div>
            <div class="magic-width back" v-if="SC.U === CHI">
              返回
            </div>
          </div> -->
        </div>

        <div class="bottom-taller"></div>
        <!-- <div class="taller"></div>
        <div class="taller"></div> -->
      </div>
    </div>
    <!-- <FloatMenu class="float-menu" @diamond="() => { fsMenu = !fsMenu }" /> -->
    <!-- <FullMenu class="full-menu" v-show="fsMenu" @close="() => { fsMenu = false }" @lang="() => { Text.toggle() }" /> -->
  </div>
</template>

<script>
// import FloatMenu from '@/components/DOM/FloatMenu/FloatMenu.vue'
// import FullMenu from '@/components/DOM/FullMenu/FullMenu.vue'
import * as Text from '@/components/DOM/Text/Text.js'

import * as ScrollMonitor from '@/components/Parts/ScrollMonitor/ScrollMonitor.js'
import CTA from '@/components/DOM/CTA/CTA.vue'

// import Instruction from './Instruction.vue'

export default {
  components: {
    CTA
    // FloatMenu,
    // FullMenu,
    // Instruction
  },
  data () {
    return {
      Text,
      SC: Text.state,
      T: Text.T,
      ENG: Text.ENG,
      CHI: Text.CHI,

      fsMenu: false,
      clean () {}
    }
  },
  mounted () {
    ScrollMonitor.setPercentage(0)
    this.setupScroll()
    window.addEventListener('resize', () => {
      this.setupScroll()
    })
  },
  methods: {
    setupScroll () {
      this.clean()
      var scroller = this.$refs['scroller']
      if (!scroller) {
        return
      }
      var content = this.$refs['content']
      var scrollerHeight = scroller.getBoundingClientRect().height
      var ccontentHeight = content.getBoundingClientRect().height
      var onScroll = () => {
        this.scrollPos = scroller.scrollTop

        ScrollMonitor.state.percentage = 0.2 * (scroller.scrollTop) / (ccontentHeight - scrollerHeight)
        // console.log(ScrollMonitor.state.percentage)
      }
      scroller.addEventListener('scroll', onScroll, false)

      this.clean = () => {
        if (scroller) {
          scroller.removeEventListener('scroll', onScroll)
        }
      }
    }
  },
  beforeDestroy () {
    this.clean()
  }
}
</script>

<style scoped>
.toc-layout{
  color: white;
  font-family: CronosPro-LtDisp, PingFangTC-Light;
}
.full-menu{
  position: absolute;
  top: 0px;
  left: 0px;
}
.float-menu{
  position: absolute;
  top: 0px;
  left: 0px;
}
.layers{
  width: 100%;
  height: 100%;
  position: relative;
  overflow:hidden;
}

.scroller{
  position: absolute;
  top: 0px;
  left: 0px;

  width: 100%;
  height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  color: white;
}
.top-taller{
  height: 20px;
}
.taller{
  height: 75vh;
}

.bottom-taller{
  height: 20px;
}

.col{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
}
.row{
  display: flex;
  justify-content: center;
}

.magic-width{
  width: 280px;
}

.title-row{
  margin-top: 10px;
}
.title{
  /* 個人資料聲明: */
  /* border: 1px solid #CEBC9E; */
  font-family: CronosPro-LtDisp, PingFangTC-Light;
  font-size: 16px;
  color: #CEBC9E;
  letter-spacing: 1.8px;
  text-align: center;
  line-height: 22px;
}

.text-row{
  margin-top: 20px;
}
.text{
  /* 資生堂集團及資生堂香港有限公司(「資生堂: */
  font-family: CronosPro-LtDisp, PingFangTC-Light;
  font-size: 13px;
  color: #FFFFFF;
  letter-spacing: 1px;
  line-height: 20px;
}

.back-row{
  margin-top: 20px;
  position: relative;
  /* width: 298.3px; */
  /* transform: scale(0.95); */
}
.back{
  font-family: CronosPro-LtDisp, PingFangTC-Light;
  font-size: 14px;
  color: #FFFFFF;
  letter-spacing: 1px;
  line-height: 20px;
  text-align: center;
  height: 65px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.back-frame{
  position: absolute;
  top: 0px;
  left: calc(50% - 320px / 2);
  transform: scale(0.95);
}


.rule-list{
  padding-left: 13px;
  width: 261px;
}
.rule-list li{
  margin-bottom: 7px;
}

@media screen and (min-width: 374px) {
  .magic-width{
    width: 304px;
  }
  .rule-list{
    width: 285px;
  }
  .text-row{
    margin-top: 8px;
  }
  .back-frame{
    transform: scale(1.02);
  }
}

@media screen and (min-width: 413px) {
  .title-row{
    margin-top: 40px;
  }
  .rule-list{
    padding-left: 18px;
  }
  .magic-width{
    width: 320px;
  }
}


@media screen and (min-width: 767px) {
  .title-row{
    margin-top: 30px;
  }
  .title{
    font-size: 30px;
  }
  .text{
    width: 550px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Pages/TOC/TOC.vue